import { ReactElement } from "react";

export const UserShieldIcon = (color?: string): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.31055 5.45381C5.31055 6.64563 5.784 7.78865 6.62675 8.63139C7.46949 9.47414 8.6125 9.94759 9.80433 9.94759C10.9962 9.94759 12.1392 9.47414 12.9819 8.63139C13.8247 7.78865 14.2981 6.64563 14.2981 5.45381C14.2981 4.26198 13.8247 3.11897 12.9819 2.27622C12.1392 1.43347 10.9962 0.960022 9.80433 0.960022C8.6125 0.960022 7.46949 1.43347 6.62675 2.27622C5.784 3.11897 5.31055 4.26198 5.31055 5.45381Z"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.06348 21.1821V18.9352C3.06348 17.7434 3.53693 16.6004 4.37967 15.7576C5.22242 14.9149 6.36543 14.4414 7.55726 14.4414H10.3659"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0177 14.9894C17.1883 14.2868 18.1875 14.2868 18.358 14.9894C18.4682 15.4432 18.9882 15.6586 19.387 15.4156C20.0044 15.0394 20.7109 15.7459 20.3348 16.3633C20.0917 16.7622 20.3071 17.2821 20.761 17.3923C21.4635 17.5629 21.4635 18.5621 20.761 18.7326C20.3071 18.8428 20.0917 19.3628 20.3348 19.7616C20.7109 20.379 20.0044 21.0855 19.387 20.7093C18.9882 20.4663 18.4682 20.6817 18.358 21.1355C18.1875 21.8381 17.1883 21.8381 17.0177 21.1355C16.9076 20.6817 16.3876 20.4663 15.9888 20.7093C15.3714 21.0855 14.6648 20.379 15.041 19.7616C15.284 19.3628 15.0687 18.8428 14.6148 18.7326C13.9122 18.5621 13.9122 17.5629 14.6148 17.3923C15.0687 17.2821 15.284 16.7622 15.041 16.3633C14.6648 15.7459 15.3714 15.0394 15.9888 15.4156C16.3876 15.6586 16.9076 15.4432 17.0177 14.9894Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8879 18.0625C18.8879 18.7252 18.3506 19.2625 17.6879 19.2625C17.0251 19.2625 16.4879 18.7252 16.4879 18.0625C16.4879 17.3997 17.0251 16.8625 17.6879 16.8625C18.3506 16.8625 18.8879 17.3997 18.8879 18.0625Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
